export default __webpack_public_path__ + "static/media/ic_stat3.f5978d6f.svg";